<template>
    <Head title="Changelog" />
    <div class="px-4 md:px-8">
        <Changelog />
    </div>
</template>
<script setup>
import { Head } from '@inertiajs/vue3';
import Changelog from '@/components/changelog/index.vue';
</script>
